module.exports = __webpack_public_path__ + "img/bull_lol2.5a756712.png";